import React, { useContext, useEffect, useState } from 'react';
import { defaultColumnDef, getPbbStrategistOverviewColumns, mapCardsData, FIRST_TAB_TABLE_HEADER } from '../aiAnalyticsHelpers.js';
import { AgGridReact } from 'ag-grid-react';
import { DEFAULT_PAGINATION_PAGE_SIZE, paginationPanel, theme, TOOLTIP_SHOW_DELAY } from '../../System/AgGrid/RegisterAgGridModules.js';
import { getStrategistOverview } from '../../../services/aiAnalyticsService.js';
import { LoaderContext } from '../../../contexts/loaderContext.js';
import StatsRow from './StatsRow.js';
import '../AiAnalytics.scss';
import { ZoomContext } from '../../../contexts/zoomContext.js';
import PropTypes from 'prop-types';
import { ForgeDivider } from '@tylertech/forge-react';

const PbbStrategistOverviewTab = ({ timePeriod }) => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGINATION_PAGE_SIZE);
  const [cardsData, setCardsData] = useState({ FIRST_ROW: [], SECOND_ROW: [] });
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const { autoHeight, gridRef } = useContext(ZoomContext);
  const { setLoading } = useContext(LoaderContext);

  const prepare = () => {

    getStrategistOverview(timePeriod.value).then(resp => {
      const data = resp.data;
      const mappedResponse = mapCardsData(data);

      setTableData(data.organizations);
      setTotalCount(data.organizations.length);
      setCardsData(mappedResponse);
      setLoading(false);
    });

  };

  useEffect(() => {
    prepare();
  }, [timePeriod]);

  return (
    <div className="dataContainer flexContainer direction-column">
      <div className="flexContainer padding withGap">
        <StatsRow data={cardsData.FIRST_ROW} />
        <StatsRow data={cardsData.SECOND_ROW} />
      </div>
      <ForgeDivider style={{ width: '100%' }} />
      <div className="padding">
        <span className="forge-typography--subheading5">{FIRST_TAB_TABLE_HEADER}</span>
      </div>
      <ForgeDivider style={{ width: '100%' }} />
      <div className="pbbStrategistTableContainer">
        <AgGridReact
          ref={gridRef}
          defaultColDef={defaultColumnDef}
          columnDefs={getPbbStrategistOverviewColumns()}
          rowData={tableData}
          animateRows={false}
          theme={theme}
          tooltipShowMode={'whenTruncated'}
          getRowId={(params) => params.data.organizationId.toString()}
          onFilterChanged={(params) => {
            setTotalCount(params.api.paginationGetRowCount());
            params.api.paginationGoToPage(0);
          }}
          tooltipShowDelay={TOOLTIP_SHOW_DELAY}
          suppressCellFocus={true}
          pagination={true}
          suppressPaginationPanel={true}
          paginationPageSize={pageSize}
          statusBar={paginationPanel(gridRef, totalCount, setPageSize, pageSize)}
          domLayout={autoHeight ? 'autoHeight' : 'normal'}
        />
      </div>
    </div>
  );
};

export default PbbStrategistOverviewTab;

PbbStrategistOverviewTab.propTypes = {
  timePeriod: PropTypes.object
};
